import type { FunctionComponent } from 'react';
import { parseHtml } from './Helper';
import { smileyImageProps } from '../Utilities/smileyImages';

type ScaleEnd = 'min' | 'max';

interface RatingScaleLabelProps {
  end: ScaleEnd;
  text?: string | null;
  showSmiley?: boolean;
}

const SIDE = { min: 'left', max: 'right' } as const;
const SMILEY = { min: 'sad', max: 'happy' } as const;

export const RatingScaleLabel: FunctionComponent<RatingScaleLabelProps> = ({
  end,
  text,
  showSmiley
}) => {
  const side = SIDE[end];

  const renderSmiley = () => {
    const { alt, style, ...img } = smileyImageProps(SMILEY[end]);
    return <img alt={alt} {...img} style={{ ...style, marginBottom: 4 }} />;
  };

  return (
    <div style={{ float: side, textAlign: side }}>
      {showSmiley && renderSmiley()}
      <div>{parseHtml(text)}</div>
    </div>
  );
};
